/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import NetworkSettingsDirective from './network-settings.directive';
import NetworkSettingsAdrTable from './adr-table/adr-table.directive';
import SessionDialogController from './session-dialog/session-dialog.controller';

export default angular.module('tektelic.networkSettings', [NetworkSettingsAdrTable])
    .controller('SessionDialogController', SessionDialogController)
    .directive('tkNetworkSettings', NetworkSettingsDirective)
    .name;



// WEBPACK FOOTER //
// ./src/app/network-settings/index.js